"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInquiryDeadlineOverdue = void 0;
const date_fns_1 = require("date-fns");
const entities_1 = require("./entities");
const RELATIVE_TO_PERIOD_DATES = {
    [entities_1.InquiryRelativeTo.StartDate]: 'startDate',
    [entities_1.InquiryRelativeTo.EndDate]: 'endDate',
    [entities_1.InquiryRelativeTo.PayoutDate]: 'payoutDate',
};
function isInquiryDeadlineOverdue({ config: { duration, relative_to }, periodDates, }) {
    const selectedDate = (0, date_fns_1.parseISO)(periodDates[RELATIVE_TO_PERIOD_DATES[relative_to]]);
    if (!(0, date_fns_1.isValid)(selectedDate))
        return false;
    const deadlineDate = (0, date_fns_1.startOfDay)((0, date_fns_1.addDays)(selectedDate, duration.days));
    const today = (0, date_fns_1.startOfDay)(new Date());
    return (0, date_fns_1.isAfter)(today, deadlineDate);
}
exports.isInquiryDeadlineOverdue = isInquiryDeadlineOverdue;
